<template>
  <div id="subOutputRank-print" class="page-break">
    <el-row>
      <el-col :span="6" :offset="9">
        <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000" v-if="AGENT == 0">{{ payableName ? payableName : this.companyName }}送货验收单</h1>
        <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000" v-if="AGENT == 1">送货验收单</h1>
      </el-col>
    </el-row>
    <el-row style="margin-top:50px;">
      <el-col :span="3">
        <img :src="imgUrl" style="width: 92%">
      </el-col>
      <el-col v-if="topData.length > 0" :span="9">
        <ul>
          <li style="margin-bottom:15px" v-if="AGENT == 0">供&nbsp;&nbsp;应&nbsp;&nbsp;商：{{supplierName}}</li>
          <li v-if="AGENT == 1">委&nbsp;&nbsp;托&nbsp;&nbsp;方：{{topData[0].PRINCIPAL_NAME}}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期：{{topData[0].SEND_DAY}}</li>
          <li>客&nbsp;户&nbsp;名&nbsp;称：{{topData[0].GYS_NAME}}</li>
        </ul>
      </el-col>
      <el-col :span="12" style="padding-left: 70px">
        <ul>
          <li style="margin-bottom:15px" v-if="AGENT == 0">制&nbsp;&nbsp;单&nbsp;&nbsp;人：{{managername}}</li>
          <li v-if="AGENT == 1">送&nbsp;&nbsp;货&nbsp;&nbsp;方：{{topData[0].TRUSTEE_NAME}}</li>
          <li>{{topData[0].PROJECT_TELPHONE}}</li>
          <li>订&nbsp;单&nbsp;编号：{{topData[0].ORDER_CODE}}</li>
          <li v-if="topData[0].SHOW_PRICE == 1">总&nbsp;金&nbsp;额：{{topData[0].TOTAL_PROJECT_FEE}}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <table style="width: 100%">
          <tr>
            <th style="width: 5%">序号</th>
            <th>编码</th>
            <th style="width: 40%">名称</th>
            <th style="width: 5%">单位</th>
            <th style="width: 10%">订购</th>
            <th style="width: 10%" v-if="sendFlag == 1">送货数量</th>
            <th style="width: 10%">实收</th>
            <th v-if="carryPrice == 1" style="width: 10%">价格</th>
            <th v-if="carryPrice == 1" style="width: 10%">总金额</th>
            <th v-if="topData[0].SHOW_PRICE == 1" style="width: 10%">价格</th>
            <th v-if="topData[0].SHOW_PRICE == 1" style="width: 10%">总金额</th>
            <th style="width: 15%">备注</th>
          </tr>
          <tr v-for="(item,index) in mainData[0]" :key="index">
            <td>{{item.ID}}</td>
            <td>{{item.PRODUCT_CODE}}</td>
            <td>{{item.PRODUCT_NAME}}</td>
            <td>{{item.TYPE_UNIT}}</td>
            <td>{{item.PRODUCT_COUNT}}</td>
            <td v-if="sendFlag == 1">{{item.NEED_COUNT}}</td>
            <td>{{item.REAL_COUNT}}</td>
            <td v-if="carryPrice == 1">{{item.REAL_PRICE}}</td>
            <td v-if="carryPrice == 1">{{item.REAL_FEE}}</td>
            <td v-if="topData[0].SHOW_PRICE == 1">{{item.PROJECT_PRICE}}</td>
            <td v-if="topData[0].SHOW_PRICE == 1 && sendFlag == 0">{{item.PROJECT_TOTAL_FEE}}</td>
            <td v-if="topData[0].SHOW_PRICE == 1 && sendFlag == 1">{{Math.round((item.NEED_COUNT * item.PROJECT_PRICE) * 100)/100}}</td>
            <td>{{item.PRODUCT_COMMENT}}</td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="18">
        <span>收货时间：</span>
      </el-col>
      <el-col :span="6" v-if="carryPrice == 1">
        <span>合计金额：{{total_real_fee}}</span>
      </el-col>
      <el-col :span="6" v-if="topData[0].SHOW_PRICE == 1 && sendFlag == 0">
        <span>合计金额：{{total_project_fee}}</span>
      </el-col>
      <el-col :span="6" v-if="(topData[0].SHOW_PRICE == 1 && sendFlag == 1)">
        <span>合计金额：{{total_prroject_need_price}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>送货员：</span>
      </el-col>
      <el-col :span="6">
        <span>项目经理：</span>
      </el-col>
      <el-col :span="6">
        <span>厨师长：</span>
      </el-col>
      <el-col :span="6">
        <span>验收人员：</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" :offset="21" style="padding: 0">
        <p>第{{mainData[0].currentPage}}页/共{{mainData[0].totalPage}}页</p>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    manager: String,
    supplier: String,
    TOTAL_REAL_FEE: Number,
    TOTAL_PROJECT_PRICE: Number,
    TOTAL_PROJECT_NEED_PRICE: Number,
  },
  data() {
    return {
      topData: [],
      mainData: [],
      managername: '',
      imgUrl: '',
      printSupplier: '',
      companyName: '',
      printName: sessionStorage.getItem('supplierName'),
      payableName: sessionStorage.getItem('payableName'),
      sendFlag: sessionStorage.getItem('sendFlag'),
      carryPrice: sessionStorage.getItem('carryPrice'),
      supplierName: '',
      AGENT: 0,
      supplier_name: '',
      total_real_fee: 0,
      total_project_fee: 0,
      total_prroject_need_price: 0,
    };
  },
  created() {
    this.AGENT = sessionStorage.getItem('AGENT');
    this.topData = this.headerData;
    this.supplier_name = this.headerData[0].SUPPLIER_NAME;
    this.mainData.push(this.tableData);
    this.managername = this.manager;
    this.printSupplier = this.supplier;
    this.companyName = sessionStorage.getItem('company');
    this.total_real_fee = this.TOTAL_REAL_FEE.toFixed(2);
    this.total_project_fee = this.TOTAL_PROJECT_PRICE.toFixed(2);
    this.total_prroject_need_price = this.TOTAL_PROJECT_NEED_PRICE.toFixed(2);
    this.imgUrl = `https://service.linkda.com.cn/file/barcode/${this.topData[0].ORDER_ID}.png`;
    if (this.printName) {
      this.supplierName = this.printName;
    } else if (this.payableName) {
      this.supplierName = this.payableName;
    } else {
      this.supplierName = this.topData[0].SUPPLIER_NAME;
    }
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}
li {
  list-style: none;
  font-size: 20px;
  line-height: 30px;
  color: #000;
  font-family: 黑体;
}
span {
  font-size: 20px;
  line-height: 35px;
  color: #000;
  font-family: 黑体;
}
table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
}
td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 20px;
  height: 30px;
  font-family: 黑体;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/supplierCusOrderTax.vue